import { ICoreContext } from '@msdyn365-commerce/core';
import { Customer } from '@msdyn365-commerce/retail-proxy';

export function hasAgreementProducts(context: ICoreContext, customer: Customer | undefined): boolean {
    const agreementProductAttributeRecordIds: Number[] | undefined = context.request.app.config?.agreementProductAttributeRecordId
        ?.split(',')
        .map(Number)
        .filter(Boolean);
    // Check if customer has any product agreement that should be shown
    const shouldShowAgreementProducts =
        agreementProductAttributeRecordIds && agreementProductAttributeRecordIds.length > 0
            ? agreementProductAttributeRecordIds.some(x => customer?.Attributes?.find(y => y.RecordId === x)?.AttributeValue?.BooleanValue)
            : false;
    return shouldShowAgreementProducts;
}

export function getAgreementProductRefinersToHide(context: ICoreContext, customer: Customer | undefined): number[] | undefined {
    const refinerIds = context.request.app.config?.agreementProductAttributeRecordId
        ?.split(',')
        .map(Number)
        .filter(Boolean) as number[] | undefined;

    // Hide all refiners if customer is not available
    if (!customer) {
        return refinerIds;
    }

    const refinersToHide = refinerIds?.filter(refinerId => {
        const attribute = customer.Attributes?.find(x => x.RecordId === refinerId);
        return !attribute?.AttributeValue?.BooleanValue;
    });

    return refinersToHide;
}
